export default "__VITE_ASSET__CSt_5_g2__"